import * as React from "react";

const CircleCrossIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM15.7547 14.2031C16.1941 14.6426 16.1941 15.3544 15.7547 15.7941C15.315 16.2338 14.6034 16.2334 14.1637 15.7941L12 13.5891L9.79547 15.7936C9.35573 16.2333 8.64422 16.233 8.20453 15.7936C7.76508 15.3541 7.76508 14.6423 8.20453 14.2027L10.4091 11.9981L8.20312 9.75469C7.76367 9.31524 7.76367 8.60344 8.20312 8.16375C8.64258 7.72406 9.35437 7.7243 9.79406 8.16375L12 10.4109L14.2045 8.20641C14.644 7.76695 15.3558 7.76695 15.7955 8.20641C16.2352 8.64586 16.2349 9.35766 15.7955 9.79734L13.5909 12.0019L15.7547 14.2031Z" fill="#262525"/>
</svg>
     
    );
};

export default React.memo(CircleCrossIcon);
